// 타이머 틱 이벤트
export class TimerTick extends CustomEvent<{ readonly timestamp: number }> {}

// 전역 타이머 관리자
export class GlobalTimerManager {
  private static instance: any;
  private timerId: number | null = null;
  private interval = 1000;
  private isRunning = false;
  private eventTarget: EventTarget = new EventTarget();
  private subscribers: Set<() => void> = new Set();

  private constructor() {}

  static getInstance(): GlobalTimerManager {
    if (!this.instance) {
      this.instance = new GlobalTimerManager();
    }
    return this.instance;
  }

  start(interval = 1000): void {
    if (this.isRunning) return;
    this.interval = interval;
    this.isRunning = true;
    this.timerId = window.setInterval(() => this.tick(), this.interval);
  }

  stop(): void {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    this.isRunning = false;
  }

  private tick(): void {
    const timestamp = Date.now();
    const event = new TimerTick('TimerTick', {
      detail: {
        timestamp,
      },
      bubbles: true,
    });

    this.eventTarget.dispatchEvent(event);
  }

  subscribe(callback: (event: TimerTick) => void): () => void {
    const handler = callback as EventListener;
    this.eventTarget.addEventListener('TimerTick', handler);

    const unsubscribe = () => {
      this.eventTarget.removeEventListener('TimerTick', handler);
      this.subscribers.delete(unsubscribe);
    };

    this.subscribers.add(unsubscribe);
    return unsubscribe;
  }

  get running(): boolean {
    return this.isRunning;
  }

  get subscriberCount(): number {
    return this.subscribers.size;
  }
}
